import { create } from 'zustand';

/**
 * Tracks devices that just finished a reflash, client-side. The reflash modal
 * marks the device on finish; the Devices page shows the "⏳ Setting up the
 * router" banner from this immediately — without waiting on a device-list
 * refresh, which itself fails while the router restarts its REST. The server's
 * reflashFinishingAt is the cross-tab/after-reload backstop.
 */
interface State {
   finishedAt: Record<string, number>; // deviceId → ms epoch
   mark: (deviceId: string) => void;
}

export const useReflashingStore = create<State>((set) => ({
   finishedAt: {},
   mark: (deviceId) =>
      set((s) => ({ finishedAt: { ...s.finishedAt, [deviceId]: Date.now() } })),
}));
